import { Helmet } from "react-helmet-async"

import PricingSection from "../components/Pricing/PricingSection"
import HraContact from "../components/Hra/HraContact"

export default function Pricing() {
	const schema = {
		"@context": "https://schema.org",
		"@type": "Product",
		"name": "HRA Pricing for ICHRA & QSEHRA | Simple, Low-Cost Plans – Salusion",
		"description": "Explore Salusion’s affordable HRA pricing—just $14/participant/month for ICHRAs and QSEHRAs. No setup or platform fees. Best features and support for small businesses.",
		"image": "https://salusion.com/assets/images/Generic.png",
		"brand": {
			"@type": "Brand",
			"name": "Your Brand"
		},
		"offers": [
			{
				"@type": "Offer",
				"name": "ICHRA",
				"description": "Individual Coverage Health Reimbursement Arrangement (ICHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "QSEHRA",
				"description": "Qualified Small Employer Health Reimbursement Arrangement (QSEHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "GCHRA",
				"description": "Group Coverage Health Reimbursement Arrangement (ICHRA)",
				"price": "5.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "5.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "EBHRA",
				"description": "Excepted Benefit Health Reimbursement Arrangement (ICHRA)",
				"price": "5.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "5.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
		]
	}

	return (
		<>
			<Helmet>
				<title>Health Reimbursement Arrangement (HRA) Pricing | Salusion</title>
				<meta name="title" content="HRA Pricing for ICHRA & QSEHRA | Simple, Low-Cost Plans – Salusion" />
				<meta name="description" content="Explore Salusion’s affordable HRA pricing—just $14/participant/month for ICHRAs and QSEHRAs. No setup or platform fees. Best features and support for small businesses." />
				<meta name="keywords" content="HRA pricing, low cost HRA, no minimum HRA, no setup fees HRA, no platform fees HRA, ICHRA pricing, QSEHRA pricing, GCHRA pricing, EBHRA pricing" />
				<link rel="canonical" href="https://salusion.com/pricing" /> 
				
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@Salusion" />
				<meta name="twitter:title" content="HRA Pricing for ICHRA & QSEHRA | Simple, Low-Cost Plans – Salusion" />
				<meta name="twitter:description" content="Explore Salusion’s affordable HRA pricing—just $14/participant/month for ICHRAs and QSEHRAs. No setup or platform fees. Best features and support for small businesses." />
				<meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" />
				<meta name="twitter:image:alt" content="Illustration of a hand offering money to another hand, representing affordable health reimbursement arrangements." />

				<meta property="og:title" content="HRA Pricing for ICHRA & QSEHRA | Simple, Low-Cost Plans – Salusion" />
				<meta property="og:description" content="Explore Salusion’s affordable HRA pricing—just $14/participant/month for ICHRAs and QSEHRAs. No setup or platform fees. Best features and support for small businesses." />
				<meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
				<meta property="og:url" content="https://salusion.com/pricing" /> 
				<meta property="og:type" content="product.group" /> <meta property="og:site_name" content="Salusion" />

				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>
			<PricingSection />
			<HraContact />
		</>
	)
}
